var map = {
	"./marker-icon-blue.png": 3465,
	"./marker-icon-green.png": 6064,
	"./marker-icon-maroon.png": 3833,
	"./marker-icon-orange.png": 8683,
	"./marker-icon-purple.png": 823,
	"./marker-icon-red.png": 6684,
	"./marker-icon-yellow.png": 5097
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1740;